const Builder = require('../BuilderBase');

module.exports = class TextColumn extends Builder {
    constructor(title, properties) {
        super('listColumn_Link', title, properties);
        if (!properties || !properties.propertyName || !properties.propertyUrl) {
            throw new Error(
                `${title} does not have a 'propertyName' or 'propertyUrl'.  You must pass a both properties when creating a link column.`
            );
        }
    }
};
